import { Icon } from '@/app/components/Icon'
import { LocalIconName } from '@/icons'
import { StructuredDataQueryResult } from '@/sanity.types'

type SocialProfiles = NonNullable<
  NonNullable<StructuredDataQueryResult>['organizationShared']
>['socialProfiles']

interface SocialProps {
  profiles: SocialProfiles | null | undefined
  className?: string
  iconSize?: number
}

const platformLabels: Record<LocalIconName, string> = {
  facebook: 'Facebook',
  twitter: 'Twitter / X',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  github: 'GitHub',
  pinterest: 'Pinterest',
}

export const Social = ({ profiles, className = '', iconSize = 24 }: SocialProps) => {
  if (!profiles) return null

  const socialLinks = (Object.keys(profiles) as LocalIconName[])
    .filter((platform) => profiles[platform])
    .map((platform) => ({
      platform,
      url: profiles[platform]!,
      label: platformLabels[platform],
    }))

  if (socialLinks.length === 0) return null

  return (
    <div className={`flex items-center gap-md ${className}`.trim()}>
      {socialLinks.map(({ platform, url, label }) => (
        <a
          key={platform}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="transition-opacity hover:opacity-70"
        >
          <Icon name={platform} size={iconSize} />
        </a>
      ))}
    </div>
  )
}
